// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#path {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  margin-bottom: -3vh;
  overflow: hidden;
  width: 100%;
}

#path-container {
  margin: 2vh auto 0;
  position: relative;
  width: 85%;
}

#path-container .category {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

#path-container .category .icon {
  align-items: center;
  border: 2px solid #233289;
  border-radius: 50%;
  display: flex;
  height: 2rem;
  justify-content: center;
  margin-right: 1rem;
  width: 2rem;
}

#path-container .category .icon img {
  height: 0.875rem;
}

#path-container .category span {
  color: #233289;
  flex: 1 1;
  font-size: 0.875rem;
  font-weight: 500;
}

#path-container .category img.chevron {
  height: 1rem;
  width: 1rem;
}

#path-container .items {
  border-left: 2px solid #233289;
  margin-left: calc(1rem + 1px);
}

#path-container .items:not(:last-of-type), #path-container .items:last-of-type:not(:empty) {
  padding: 0.5rem 0;
}

#path-container .items .item {
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 2vh;
  box-shadow: 0 3.5px 6px rgba(0, 0, 0, 0.05);
  color: #07144C;
  margin-left: 1rem;
  padding: 1rem;
}

#path-container .items .item:not(:last-of-type) {
  margin-bottom: 1rem;
}

#path-container .items .item .form-check .form-check-input {
  background-color: transparent;
  border-color: #233289;
  border-width: 2px;
  cursor: pointer;
}

#path-container .items .item .form-check .form-check-input:checked {
  background-color: #233289;
}

#path-container .items .item .form-check label {
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: underline;
}

#path-container .items .item .description {
  cursor: pointer;
  font-size: 0.67rem;
  margin-top: 0.5rem;
  text-decoration: underline;
}

#path .info {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 2vh;
  box-shadow: 0 3.5px 6px rgba(0, 0, 0, 0.05);
  color: #4B5563;
  display: flex;
  font-size: 0.67rem;
  font-weight: 500;
  height: 6vh;
  margin: 2vh auto;
  width: 85%;
}

#path .info img {
  margin-left: 5%;
  margin-right: 0.5rem;
  width: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/path/Path.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb","sourcesContent":["#path {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  margin-bottom: -3vh;\n  overflow: hidden;\n  width: 100%;\n}\n\n#path-container {\n  margin: 2vh auto 0;\n  position: relative;\n  width: 85%;\n}\n\n#path-container .category {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n}\n\n#path-container .category .icon {\n  align-items: center;\n  border: 2px solid #233289;\n  border-radius: 50%;\n  display: flex;\n  height: 2rem;\n  justify-content: center;\n  margin-right: 1rem;\n  width: 2rem;\n}\n\n#path-container .category .icon img {\n  height: 0.875rem;\n}\n\n#path-container .category span {\n  color: #233289;\n  flex: 1;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n#path-container .category img.chevron {\n  height: 1rem;\n  width: 1rem;\n}\n\n#path-container .items {\n  border-left: 2px solid #233289;\n  margin-left: calc(1rem + 1px);\n}\n\n#path-container .items:not(:last-of-type), #path-container .items:last-of-type:not(:empty) {\n  padding: 0.5rem 0;\n}\n\n#path-container .items .item {\n  background-color: rgba(255, 255, 255, 0.6);\n  border-radius: 2vh;\n  box-shadow: 0 3.5px 6px rgba(0, 0, 0, 0.05);\n  color: #07144C;\n  margin-left: 1rem;\n  padding: 1rem;\n}\n\n#path-container .items .item:not(:last-of-type) {\n  margin-bottom: 1rem;\n}\n\n#path-container .items .item .form-check .form-check-input {\n  background-color: transparent;\n  border-color: #233289;\n  border-width: 2px;\n  cursor: pointer;\n}\n\n#path-container .items .item .form-check .form-check-input:checked {\n  background-color: #233289;\n}\n\n#path-container .items .item .form-check label {\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-decoration: underline;\n}\n\n#path-container .items .item .description {\n  cursor: pointer;\n  font-size: 0.67rem;\n  margin-top: 0.5rem;\n  text-decoration: underline;\n}\n\n#path .info {\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.6);\n  border-radius: 2vh;\n  box-shadow: 0 3.5px 6px rgba(0, 0, 0, 0.05);\n  color: #4B5563;\n  display: flex;\n  font-size: 0.67rem;\n  font-weight: 500;\n  height: 6vh;\n  margin: 2vh auto;\n  width: 85%;\n}\n\n#path .info img {\n  margin-left: 5%;\n  margin-right: 0.5rem;\n  width: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
